import { ApolloClient, ApolloLink } from '@apollo/client';

import createCache from './cache';
import type { ClientOptions } from './types';

export default ({
  links = [],
  httpLink,
  cacheOptions,
  cache,
  ...restOptions
}: ClientOptions) =>
  new ApolloClient({
    connectToDevTools: true,
    link: ApolloLink.from([...links, httpLink(restOptions)]),
    cache: cache || createCache(cacheOptions),
  });
